import { render } from "./Candidatos.vue?vue&type=template&id=ef1ca6be&scoped=true"
import script from "./Candidatos.vue?vue&type=script&lang=js"
export * from "./Candidatos.vue?vue&type=script&lang=js"

import "./Candidatos.vue?vue&type=style&index=0&id=ef1ca6be&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef1ca6be"]])

export default __exports__